import { CONVERT_SECTION } from '@services/permissions'

import type { Section } from '../types'

export const convertDetailSection: Section = {
  label: 'layout:page.convert.title',
  route: '/convert/[id]',
  permissions: CONVERT_SECTION,
}

export const convertSection: Section = {
  label: 'layout:page.convert.title',
  route: '/convert',
  icon: 'SwitchHorizontalOutline',
  permissions: CONVERT_SECTION,
  pages: [convertDetailSection],
}
